import axios from "axios";
import { classifyAxiosError } from "./errors";

const fallbackURL = "https://mohren-strapi-new-vs7i8.ondigitalocean.app";

// In dev mode use relative paths so requests always target the same origin
// the WebView/browser is on. Vite's dev proxy then forwards them to the real
// CMS. This avoids CORS between the WebView host (e.g. 10.0.2.2 on Android
// emulator or the LAN IP on iOS) and the API target.
const instance = axios.create({
  baseURL: import.meta.env.DEV
    ? ""
    : import.meta.env.VITE_CMS_URL || fallbackURL,
  timeout: 25000,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

const AUTH_LOCAL_STORAGE_KEYS = [
  "user",
  "token",
  "mohren_token",
  "watched_stories",
];

export const handleUnauthorized = () => {
  for (const key of AUTH_LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
  try {
    window.dispatchEvent(new Event("auth:unauthorized"));
  } catch {}
};

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const appError = classifyAxiosError(error);
    if (appError.kind === "unauthorized") {
      handleUnauthorized();
    }
    return Promise.reject(appError);
  }
);

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("mohren_token");
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any).Authorization = "Bearer " + token;
  }
  return config;
});

export default instance;
